export default "__VITE_ASSET__KyCEET0X__"